import React from 'react';
import {Container, Grid, Typography} from "@mui/material";
import {Formik} from "formik";
import AccessCodeForm from "../../../components/GuestInfo/GuestForm/AccessCodeForm";
import {requestApi, showAlertAutoDis} from "../../../utils/utils";
import {useHistory, useParams} from "react-router-dom";

const GuestAccessPage = () => {
    const sessionAccessCode = sessionStorage.getItem('accessToken');
    const history = useHistory();
    const {id: guestId} = useParams();

    const initialValues = {
        accessToken: sessionAccessCode || '',
    };

    const handleSubmit = async (values) => {
        const {data} = await requestApi('/guest/valid-access-token', 'POST', {guestCode: values.accessToken});
        if (!data.valid)
            return showAlertAutoDis({title: 'Error', text: 'Access token is invalid or expired.'});

        sessionStorage.setItem('accessToken', values.accessToken);
        return history.push(`${window['appBasename']}/booking/guest/${guestId}/personal-information`);
    };

    return (
        <Container sx={{px: '1.6rem !important'}}>
            <div style={{marginTop: '50px', marginBottom: '50px'}}>
                <Grid container item xs={12} spacing={3} sx={{px: {xs: '2.4rem', lg: '0', display: 'flex', flexDirection: 'column'}}}>
                    <Typography variant="h3">Guest Information</Typography>
                    <p>Enter your Guest Access Code to continue.</p>
                    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
                        {(props) => <AccessCodeForm {...props} />}
                    </Formik>
                </Grid>
            </div>
        </Container>
    );
};

export default GuestAccessPage;